/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const alert = require('components/base/pop/alert');

require('./welcome.scss');
const template = require('./welcome.tpl');

module.exports = {
  name: "welcome",
  template,
  ready() {
    alert({
      title: 'welcome',
      message: 'welcome'
    });

     // window.localStorage.setItem('TOKEN', "828462d3625948cebfb2a224f76b128d");
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/components/page/welcome/welcome.js